__webpack_require__.p = "https://www.d-rosa.ai/";